<template>
  <div>
		<div style="margin-bottom: 10px;">
			<span>{{$t('gather')+$t('inbound')+$t('caseNumber')}}：{{tableData.total_nums || 0}}</span> </span>
			<span style="margin: 0 10px;">{{$t('BeforeOverseaWarehouse')+$t('caseNumber')}}：<span style="color:green">{{tableData.total_nums - tableData.wait_nums || 0}}</span></span>
			<span>{{$t('not_stock')+$t('caseNumber')}}：<span style="color:red">{{tableData.wait_nums || 0}}</span></span>
		</div>
    <Table
      :columns="tableTitle"
      :data="tableData.data"
      border
      stripe
      height="600"
    >
      <template
        v-for="(item, index1) in tableTitle"
        :slot="item.slot"
        slot-scope="{ row, index }"
      >
        <template v-if="item.button">
          <Button
            :type="row.id ? 'success' : 'warning'"
            @click="handSubmit(row)"
            size="small"
            :key="index1"
            v-if="hasPermission(432) || hasPermission(433)"
          >
            {{ row.id ? $t("update") : $t("order_submit") }}
          </Button>
					
        </template>
        <DatePicker
          :key="index1"
          v-model="tableData.data[index][item.slot]"
          v-else-if="item.DatePicker"
          type="datetime"
          :placeholder="$t('select') + $t('date') + $t('time')"
          style="width: 170px"
          :options="item.pickerOptions"
        ></DatePicker>
        <Input
          :key="index1"
          v-model="tableData.data[index][item.slot]"
          v-else-if="item.input"
          :disabled="tableData.done"
        >
        </Input>
        <InputNumber
          :key="index1"
          v-model="tableData.data[index][item.slot]"
          v-else-if="item.inputNumber"
          :disabled="tableData.done || item.disabled"
          :step="item.step"
          :min="0"
					style="width: 100%;"
					@input="()=>item.change &&item.change(index)"
        >
        </InputNumber>
      </template>
    </Table>
  </div>
</template>
<script>
import {
  getB2bOutbound,
  addB2bOutbound,
  updateOutbound,
	Del,
} from "@/api/double/list";

import boxMes from "@/utils/message";
import format from "@/utils/format";
// import { getWarehouse } from "@/api/storage/warehouse";

export default {
  props: {
    billId: {
      type: String,
    },
  },
  data() {
    return {
      tableData: {},
      loading: true,
      pageCurrent: 1,
      showModal: false,
      title: "",
      num: "",
      remarks: "",
      warehouseList: [],
    };
  },
  computed: {
    tableTitle() {
      let columns = [];
      columns.push({
        title: this.$t("warehouseName"),
        key: "warehouse_name",
        align: "center",
        minWidth: 100,
      });
			columns.push({
			  title: this.$t("childOrder"),
			  key: "case_number",
			  align: "center",
			  minWidth: 100,
			});
			columns.push({
			  title: this.$t("out") + this.$t("caseNumber"),
			  slot: "quantity",
			  align: "center",
			  minWidth: 100,
			  step: 1,
			  inputNumber: true,
			});
			columns.push({
			  title: this.$t("skuVolume")+'(CBM)',
			  slot: "volume",
			  align: "center",
			  minWidth: 120,
			  step: 1,
			  inputNumber: true,
			});
      
			columns.push({
			  title: this.$t("actual_weight")+'(KG)',
			  slot: "actual_weight",
			  align: "center",
			  minWidth: 125,
			  step: 1,
			  inputNumber: true,
			});
      columns.push({
        title: this.$t("order_pcs"),
        slot: "package_number",
        align: "center",
        minWidth: 115,
        step: 1,
        inputNumber: true,
      });
      columns.push({
        title: this.$t("out") + this.$t("time"),
        slot: "outbound_time",
        align: "center",
        minWidth: 200,
        DatePicker: true,
        pickerOptions: {
          // disabledDate(time) {
          //   return time.getTime() > Date.now();
          // },
        },
      });
      columns.push({
        title: this.$t("order_desc"),
        slot: "remarks",
        align: "center",
        tooltip: true,
        minWidth: 100,
        input: true,
      });
			columns.push({
			  title: this.$t("createTime"),
			  key: "create_time",
			  align: "center",
			  width: 110,
			});
			columns.push({
			  title: this.$t("operate"),
			  key: "operator_name",
			  align: "center",
			  tooltip: true,
			  minWidth: 100,
			});
			if (!this.tableData.done) {
        columns.push({
          title: this.$t("operation"),
          slot: "btn",
          align: "center",
          button: true,
          width: 80,
        });
      }
      return columns;
    },
  },
  mounted() {
    // getWarehouse().then(res => {
    //   this.warehouseList = res.data.payload.rows;
    // });
    this.getList(this.billId);
  },
  methods: {
    hasPermission(id) {
      return this.$hasPermission(id);
    },
		
    handSubmit(row) {
      // if (row.remarks == "" || row.quantity == "") {
      //   this.$Message["error"]({
      //     background: true,
      //     content: "出库数量，备注不能为空",
      //     duration: 5
      //   });
      // } else {
      //   var reg = /^\d+(?=\.{0,1}\d+$|$)/;
      //   if (!reg.test(row.quantity)) {
      //     this.$Message["error"]({
      //       background: true,
      //       content: "请输入大于等于0的正数",
      //       duration: 5
      //     });
      //     return;
      //   }
      let data = {
        quantity: row.quantity,
        remarks: row.remarks,
        package_number: row.package_number,
				actual_weight: row.actual_weight,
				volume:  row.volume,
        outbound_time: row.outbound_time
          ? format.timeFormat(JSON.parse(JSON.stringify(row.outbound_time)))
          : "",
      };
      if (row.id) {
        data.id = row.id;
        updateOutbound(data).then((res) => {
          this.$Message[res.data.status ? "success" : "error"]({
            background: true,
            content: res.data.msg,
            duration: 5,
          });
          if (res.data.status) {
            this.getList(this.billId);
            this.$parent.$parent.$page.getList();
            this.$parent.$parent.$page.closeLoading();
          }
        });
        return;
      }
      addB2bOutbound(this.billId, data).then((res) => {
        this.$Message[res.data.status ? "success" : "error"]({
          background: true,
          content: res.data.msg,
          duration: 5,
        });
        if (res.data.status) {
          this.getList(this.billId);
        }
      });
    },
    closeModal() {
      this.closedeleteModal(false);
    },
    closedeleteModal(e) {
      if (e === false) {
        this.showModal = false;
        this.searchFrom.keywords = "";
        this.feeData = [];
        this.$refs["dataDetails"].resetFields();
      }
    },
    getList(id) {
      this.tableData = {};
      this.loading = true;
      getB2bOutbound(id)
        .then((res) => {
          if (!res.data.status) {
            this.loading = false;
            boxMes.alertMes(res, this);
            return;
          }
          this.tableData = res.data.payload;
          if (!res.data.payload.done) {
            this.tableData.data.unshift({
              airway_bill_number: "",
              remarks: "",
              quantity: 0,
              actual_weight: 0,
              volume:  0,
              total_nums: res.data.payload.total_nums,
              package_number: 0,
              create_time: "",
              operator_name: "",
              warehouse_name: "",
              outbound_time: "",
            });
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped lang="less">
.delBtn {
  margin: 0 10px;
}
.ivu-page {
  margin-top: 20px;
}
.footer-modal {
  width: 100%;
  text-align: center;
}
.bill-form .ivu-form-item {
  margin-bottom: 10px;
}
</style>
